/* fmf-lazy-country-20261008
 * Country selector loaded on demand. The page only ships a small placeholder button
 * (snippets/country-localization.liquid, non-LazyCountry branch). The full country list
 * is fetched from sections/fmf-country-selector.liquid via the Section Rendering API
 * when the visitor hovers, focuses, touches or clicks the button.
 */
(function () {
  if (window.__fmfCountryLazy) return;
  window.__fmfCountryLazy = true;

  var SECTION_ID = 'fmf-country-selector';
  var pending = null;

  function fetchPayload() {
    if (!pending) {
      var url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('section_id', SECTION_ID);
      pending = fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .catch(function (err) {
          pending = null;
          throw err;
        });
    }
    return pending;
  }

  function hydrate(trigger, open) {
    var holder = trigger.closest('[data-fmf-country-lazy]');
    var oldForm = holder && holder.closest('localization-form');
    if (!holder || !oldForm || holder.dataset.state === 'loading') return;
    holder.dataset.state = 'loading';
    trigger.setAttribute('aria-busy', 'true');

    var position = holder.getAttribute('data-fmf-country-lazy') || 'LazyCountry';

    fetchPayload()
      .then(function (html) {
        var tpl = document.createElement('template');
        tpl.innerHTML = html.split('LazyCountry').join(position);
        var newForm = tpl.content.querySelector('localization-form');
        if (!newForm) throw new Error('Country selector payload missing');

        Array.prototype.forEach.call(oldForm.attributes, function (attr) {
          newForm.setAttribute(attr.name, attr.value);
        });
        var oldHeading = oldForm.querySelector('h2');
        var newHeading = newForm.querySelector('h2');
        if (oldHeading && newHeading) newHeading.replaceWith(oldHeading.cloneNode(true));

        // The payload was rendered for "?section_id=..."; send the visitor back to this page instead.
        var returnTo = newForm.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.value = window.location.pathname + window.location.search;

        if (document.activeElement === trigger) trigger.blur();
        oldForm.replaceWith(newForm);

        if (open) {
          requestAnimationFrame(function () {
            var btn = newForm.querySelector('button.localization-form__select');
            if (btn) btn.click();
          });
        }
      })
      .catch(function () {
        holder.dataset.state = '';
        trigger.removeAttribute('aria-busy');
      });
  }

  function findTrigger(event) {
    return event.target && event.target.closest ? event.target.closest('[data-fmf-country-trigger]') : null;
  }

  function prefetch(event) {
    if (findTrigger(event)) fetchPayload().catch(function () {});
  }

  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);
  document.addEventListener('click', function (event) {
    var trigger = findTrigger(event);
    if (trigger) hydrate(trigger, true);
  });
})();
